import React, { useState, useEffect } from "react";

import "./App.css";
import Header from "./component/header";
import Footer from "./component/footer";
import Container from "./component/container";
import CoverPanel from "./component/coverPanel";
import LogoPanel from "./component/logoPanel";
import CardComponent from "./component/cardComponent";
import CoreValues from "./component/coreValues";
import ContactUs from "./component/contactUs";
import Services from "./component/services";
import InitVideo from "./component/initVideo";
import "./style/style.css";
import "./style/hexagon.css";

function App() {
  const [showModel, setShowMdel] = useState(true);
  const toggleModel = () => {
    setShowMdel(!showModel);
  };

  useEffect(() => {
    window.onscroll = function() {scrollFunction()};

function scrollFunction() {
      let mybutton = document.getElementById("scroll_top");
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }
  })

  const scrollToTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'})
  }

  return (
    <div className="App">
      <div className="bg-image">
        <div id="home">
          <Header />
          <LogoPanel />
          <CoverPanel />
        </div>
        <div className="contact-padd" id="about-us">
          <Container />
          <CardComponent />
          <CoreValues />
        </div>
        <div id="servies" className="services-padd services-padd-btm">
          <Services />
        </div>
        <div className="contact-padd contact-margin" id="contact-us">
          <ContactUs />
        </div>
        <Footer />
        <footer className="app-footer">Terms of use <span>.</span> Privacy and Security <span>.</span> Copyright @2020 BEEHIVES</footer>
      </div>
      <button id="scroll_top" onClick={scrollToTop} title="Go to top">Top</button>
      {showModel ? <InitVideo toggleModel={toggleModel} /> : null}
    </div>
  );
}

export default App;
